import { render } from "./HeaderFilesPreview.vue?vue&type=template&id=ab5491e8&scoped=true"
import script from "./HeaderFilesPreview.vue?vue&type=script&lang=js"
export * from "./HeaderFilesPreview.vue?vue&type=script&lang=js"

import "./HeaderFilesPreview.vue?vue&type=style&index=0&id=ab5491e8&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5491e8"]])

export default __exports__